import { render } from "./Informations_Donation.vue?vue&type=template&id=12fe9c63"
import script from "./Informations_Donation.vue?vue&type=script&lang=js"
export * from "./Informations_Donation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__